import { AbstractControl } from '@angular/forms'
import { Arn } from './types'

const GUID_REGEX = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i

export function sanitizeAzureSubscriptionId(subscriptionId: string) {
  return subscriptionId.trim()
}

export function validAzureSubscriptionId(subscriptionId: string) {
  // may need to beef this up
  return !!subscriptionId && GUID_REGEX.test(subscriptionId)
}

export function sanitizeAzureRegion(region: string) {
  return region.trim()
}

export function wellFormedAzureSubscriptionId(control: AbstractControl) {
  let awsAccountId = sanitizeAzureSubscriptionId(control.value)
  let valid = awsAccountId === '' || validAzureSubscriptionId(awsAccountId)
  return valid ? null : { malformedAccountId: awsAccountId }
}

export var minPasswordLength = 12

export function parseArn(arn: Arn) {
  const segments = arn.split(':')
  const [, partition, service, region, accountId, ...resource] = segments
  return { partition, service, region, accountId, resource }
}
